import {
  useQuery,
  QueryResult,
  QueryOptions,
  WatchQueryFetchPolicy,
} from '@apollo/client';
// Api
import { GET_SPORTS } from 'api/sports/queries';
// Types
import { Sports, SportsVariables } from 'api/sports/types/Sports';
import { GetSportsInput } from 'api/graphql-global-types';

type BasicQueryOptions = Omit<
  QueryOptions,
  'query' | 'variables' | 'fetchPolicy'
> & {
  fetchPolicy?: WatchQueryFetchPolicy;
};

type UseGetSportsOptions = {
  options?: BasicQueryOptions;
  variables?: GetSportsInput;
};

export const useGetSports = (
  options?: UseGetSportsOptions
): QueryResult<Sports, SportsVariables> => {
  const sports = useQuery<Sports, SportsVariables>(GET_SPORTS, {
    variables: {
      input: {
        ...options?.variables,
      },
    },
    ...options?.options,
  });

  return sports;
};
